/**
 * Relay Environment Provider
 *
 * Wraps components that need access to Relay
 */

import React, { useEffect } from 'react';
import { RelayEnvironmentProvider } from 'react-relay';
import { relayEnvironment } from './environment';
import { useAdminStore } from '../store/adminStore';
import { history } from '../utils';
import CustomToast from '../components/Redesing/custom-toast';

interface RelayProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component that makes Relay available to child components
 *
 * @example
 * <RelayProvider>
 *   <App />
 * </RelayProvider>
 */
export function RelayProvider({ children }: RelayProviderProps) {
  const setAdmin = useAdminStore((state) => state.setAdmin);

  useEffect(() => {
    const handleUnauthorized = () => {
      CustomToast({
        id: 'session-expired',
        type: 'error',
        message: 'Your session has expired, please log back in',
      });

      localStorage.removeItem('adminDate');
      localStorage.removeItem('admin');

      setAdmin({
        admin: null,
        adminDate: null,
      });

      history.push('/login');
    };

    window.addEventListener('api:unauthorized', handleUnauthorized);

    return () => {
      window.removeEventListener('api:unauthorized', handleUnauthorized);
    };
  }, [setAdmin]);

  return (
    <RelayEnvironmentProvider environment={relayEnvironment}>
      {children}
    </RelayEnvironmentProvider>
  );
}

export default RelayProvider;
